import {Button, showNotification} from 'platform/components';

import {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

import {selectAudit, selectCarAudit} from '../../../store/carAudit/selectors';
import {useConditionContext} from '../hooks/useConditionContext';
import {useVideoUploadContext} from '../hooks/useVideoUploadContext';

export const VerifyCondition = (props: TestIdProps) => {
  const audit = useSelector(selectAudit);
  const {loading} = useSelector(selectCarAudit);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {loadActualData} = useConditionContext();
  const {isUploadInProgress} = useVideoUploadContext();

  const handleVerify = async (): Promise<void> => {
    if (!audit) {
      return;
    }

    setIsLoading(true);

    await loadActualData(audit.id).then(() =>
      showNotification.success(i18n.t('entity.inspection.notifications.conditionAreUpToDate'))
    );

    setIsLoading(false);
  };

  const isDisabled = useMemo(() => {
    if (isLoading) {
      return false;
    }

    const {updateAudit, getAuditAsset, imageUpload, deleteAuditAsset} = loading;

    return updateAudit || getAuditAsset || imageUpload || deleteAuditAsset || isUploadInProgress;
  }, [isLoading, loading, isUploadInProgress]);

  return (
    <Button
      onClick={handleVerify}
      isDisabled={isDisabled}
      isLoading={isLoading}
      data-testid={suffixTestId('verifyCondition', props)}
      title={i18n.t('general.actions.refresh')}
      leftIcon="navigation/refresh"
      variant="outlined"
    />
  );
};
